/**
 * Verrou de défilement partagé par toutes les fenêtres du thème.
 *
 * Le problème qu'il résout : bloquer le défilement en posant `overflow: hidden`
 * sur la page suffit à empêcher le scroll, mais la position n'est pas conservée.
 * Le navigateur ramène la page en haut, et à la fermeture on se retrouve au
 * début au lieu de l'endroit qu'on lisait.
 *
 * La position est donc mémorisée à la fermeture du verrou et rétablie à la
 * réouverture, en neutralisant au passage le `scroll-behavior: smooth` du thème :
 * sans ça, le retour se ferait en une animation de plusieurs centaines de
 * millisecondes, ce qui se lit comme un bug.
 *
 * Un compteur permet à deux fenêtres superposées de cohabiter : le verrou ne
 * saute que quand la dernière se ferme.
 *
 *   window.zoemassScrollLock.lock();
 *   window.zoemassScrollLock.unlock();
 */
(function () {
  'use strict';

  if (window.zoemassScrollLock) return;

  var depth = 0;
  var saved = 0;

  function lock() {
    if (depth === 0) {
      saved = window.scrollY || window.pageYOffset || 0;
      /* iOS ignore `overflow: hidden` sur <html> : le doigt continue de faire
         défiler la page derrière la fenêtre. Le seul verrou fiable y est de
         figer le corps de page, ce qui impose de le remonter d'autant qu'on
         avait défilé, sinon la page saute en haut au moment du verrouillage. */
      document.documentElement.style.setProperty('--zm-scroll-top', '-' + saved + 'px');
      document.documentElement.classList.add('zm-scroll-locked');
    }
    depth += 1;
  }

  function unlock() {
    depth = Math.max(depth - 1, 0);
    if (depth > 0) return;

    var html = document.documentElement;
    html.classList.remove('zm-scroll-locked');
    html.style.removeProperty('--zm-scroll-top');

    // Retour instantané : le thème déclare scroll-behavior: smooth sur <html>,
    // qui transformerait ce rétablissement en une longue glissade.
    var previous = html.style.scrollBehavior;
    html.style.scrollBehavior = 'auto';
    window.scrollTo(0, saved);
    html.style.scrollBehavior = previous;
  }

  window.zoemassScrollLock = { lock: lock, unlock: unlock };
})();
